import { render } from "./Main.vue?vue&type=template&id=5791222b&scoped=true"
const script = {}

import "./Main.vue?vue&type=style&index=0&id=5791222b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5791222b"]])

export default __exports__